var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconServiceCoinwashing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.382,
    height: 60.721,
    viewBox: "0 0 55.382 60.721",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_38725",
    "data-name": "\\uADF8\\uB8F9 38725",
    transform: "translate(1.2 1.2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_58",
    "data-name": "\\uC0AC\\uAC01\\uD615 58",
    width: 52.982,
    height: 58.321,
    rx: 10,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_8",
    "data-name": "\\uD0C0\\uC6D0 8",
    cx: 18.405,
    cy: 18.405,
    r: 18.405,
    transform: "translate(8.086 13.425)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_83",
    "data-name": "\\uD328\\uC2A4 83",
    d: "M400.811,1215.646a5,5,0,0,1-4.3-2.455,4.994,4.994,0,0,1-8.6,0,4.988,4.988,0,0,1-7.247,1.489,11.747,11.747,0,0,0,23.406-.245A4.98,4.98,0,0,1,400.811,1215.646Z",
    transform: "translate(-365.866 -1181.72)",
    fill: "#f09",
    stroke: "#000c7a",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_84",
    "data-name": "\\uD328\\uC2A4 84",
    d: "M400.811,1215.646a5,5,0,0,1-4.3-2.455,4.994,4.994,0,0,1-8.6,0,4.988,4.988,0,0,1-7.247,1.489,11.747,11.747,0,0,0,23.406-.245A4.98,4.98,0,0,1,400.811,1215.646Z",
    transform: "translate(-365.866 -1181.72)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9",
    "data-name": "\\uD0C0\\uC6D0 9",
    cx: 2.834,
    cy: 2.834,
    r: 2.834,
    transform: "translate(6.106 4.748)",
    fill: "#1a1311",
    stroke: "#000c7a",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_10",
    "data-name": "\\uD0C0\\uC6D0 10",
    cx: 2.834,
    cy: 2.834,
    r: 2.834,
    transform: "translate(15.5 4.748)",
    fill: "#1a1311",
    stroke: "#000c7a",
    strokeWidth: 2.4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServiceCoinwashing);
export default __webpack_public_path__ + "static/media/icon-service-coinwashing.ecf8da093548376d12bbd5b112d02b87.svg";
export { ForwardRef as ReactComponent };